/** @type {import('../help-index.js').HelpSidebarItem} */
export const FIN_CRC_COUPON_CONTROL_ITEM = {
  id: 'coupon-control',
  screenId: 'fin-crc-coupon-control',
  label: 'Control de cupones',
  description: 'Archivo de la procesadora vs cupones del sistema.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Subís el informe que te envía la procesadora de tarjetas y lo comparás con los cupones registrados en el sistema. Así verificás que cada venta cobrada con tarjeta coincida con lo informado por el banco o procesadora.',
      },
      {
        title: 'Paso 1 — Listado de archivos cargados',
        fields: [
          { label: 'Fecha desde / Fecha hasta', description: 'Período de las cargas de control.' },
        ],
        bullets: [
          'Columnas: Fecha, Proveedor, Fecha desde, Fecha hasta, Usuario, Fecha carga.',
          'Tocá una fila para abrir las líneas del archivo y conciliar.',
          'La papelera elimina el archivo de control completo (columna Acción).',
        ],
      },
      {
        title: 'Paso 2 — Nueva carga de cupones',
        intro: 'El botón + abre la ventana de carga:',
        fields: [
          { label: 'Proveedor de tarjeta de crédito', description: 'Procesadora a la que corresponde el archivo.' },
          {
            label: 'Archivo',
            description: 'Excel (.xlsx, .xls) o CSV separado por comas. Máximo 2 MB y 300 filas. Si tenés más, dividí en varios archivos.',
          },
        ],
        paragraphs: [
          'Al procesar, el sistema avisa cuántos cupones importó y si omitió duplicados ya usados en otro control.',
          'Entrás directo a la pantalla de emparejamiento.',
        ],
      },
      {
        title: 'Paso 3 — Emparejar líneas del archivo con el sistema',
        intro: 'La grilla tiene dos bloques: a la izquierda la línea del archivo de control; a la derecha el cupón del sistema (si ya hay match).',
        bullets: [
          'Tocá una fila para abrir el detalle y «Asignar conciliación» o «Cambiar conciliación».',
          'La lista se ordena por fecha y número de cupón del archivo.',
          'Si el sistema tiene un cupón en esas fechas que no está en el archivo, aparece a la derecha con la izquierda vacía.',
          'Elegí el cupón del sistema en la lista de disponibles. El monto debe coincidir (con tolerancia mínima); si no, el sistema avisa.',
          '«Eliminar conciliación» quita el vínculo de esa línea.',
          '«Auto reconciliación» intenta emparejar en lote todas las líneas pendientes.',
          '«Guardar conciliación» persiste los vínculos. Hasta guardar, los cambios pueden perderse al salir.',
          'La flecha atrás vuelve al listado de archivos.',
        ],
      },
      {
        title: 'Relación con Cupones y Liquidaciones',
        paragraphs: [
          'Un cupón marcado como controlado en «Cupones» pasó por este proceso.',
          'Las liquidaciones diarias usan cupones ya controlados para conciliar el depósito en banco.',
        ],
      },
    ],
  },
}
